import { TableColumn } from '../../../components/forms/form-entries/form-entry-list/entry-list/dynamic-table/dynamic-table.component';
import { TrenchingExcavationWorkPlan } from './trenching-excavation-work-plan.model';

export class TrenchingExcavationWorkPlanListItem {
  /** When the form was submitted ("Entry Date" column) */
  submissionDate: Date | null = null;

  /** The person who submitted the form ("User" column) */
  submittedByName: string | null = null;

  date: Date | null = null;
  jobsiteNameAddress: string | null = null;
  competentPersonName: string | null = null;


  id: string = '';

  constructor(data?: Partial<TrenchingExcavationWorkPlanListItem>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  static getTableColumns(): TableColumn[] {
    const columns: TableColumn[] = [];
    const instance = new TrenchingExcavationWorkPlanListItem();
    const fieldMappings = TrenchingExcavationWorkPlan.getFieldMappings();

    Object.keys(instance).forEach(key => {
      if (key === 'id') return;

      let type: 'text' | 'date' | 'action' | 'status' = 'text';
      const value = instance[key as keyof TrenchingExcavationWorkPlanListItem];

      if (value instanceof Date || (value === null && key.toLowerCase().includes('date'))) {
        type = 'date';
      }

      if (fieldMappings[key]) {
        columns.push({
          key,
          label: fieldMappings[key],
          type,
          sortable: true,
        });
      }
    });

    return columns;
  }

  static fromApiResponse(data: any): TrenchingExcavationWorkPlanListItem {
    return new TrenchingExcavationWorkPlanListItem({
      id: data.id,
      submissionDate: data.submissionDate ? new Date(data.submissionDate) : null,
      submittedByName: data.submittedByName,
      date: data.date ? new Date(data.date) : null,
      jobsiteNameAddress: data.jobsiteNameAddress,
      competentPersonName: data.competentPersonName,

    });
  }
}
